'use strict';

import { ajax } from '../../_scripts/commons/ajax'

export default class Autocomplete {
  constructor() {
    (function($) {
      $.extend({
        bookmark: {
          init: $obj => {
            const bookmarkConfig = $obj.data('bookmark');

            $obj.data('has-bookmark', true);

            $obj.attr('data-has-bookmark', true);

            let $toolbar = $obj.find('[data-toolbar]');

            if (!$toolbar.length) {
              $toolbar = $('<div>', {
                'data-toolbar': true
              });

              if ($obj.css('position') === 'static') {
                $obj.css('position', 'relative');
              }

              $obj.append($toolbar);
            }

            $toolbar[bookmarkConfig.mode || 'append']($('<div>', {
              class: 'tooblar-item bookmark-toggler' + (bookmarkConfig.active ? ' active' : ''),
              'data-toggle': 'bookmark'
            }).html($('<i>', {
              class: 'material-icons bookmark-on'
            }).html('star')).append($('<i>', {
              class: 'material-icons bookmark-off'
            }).html('star_border')));
          },
          toggle: $obj => {
            const $bookmarkContainer = $obj.closest('[data-bookmark]');

            const bookmarkConfig = $bookmarkContainer.data('bookmark');

            const $bookmarksGroup = $obj.closest('[data-bookmarks-group]');

            if ($bookmarksGroup.length && $obj.hasClass('active')) {
              return;
            }

            $.bookmark[$obj.hasClass('active') ? 'remove' : 'add']($obj);
          },
          add: $obj => {
            const $bookmarkContainer = $obj.closest('[data-bookmark]');

            const bookmarkConfig = $bookmarkContainer.data('bookmark');

            const $bookmarksGroup = $obj.closest('[data-bookmarks-group]');

            ajax.run({
              url: bookmarkConfig.urls.add
            }).then(json => {
              if (json.status === 'success') {
                if ($bookmarksGroup.length) {
                  $bookmarksGroup.find('[data-toggle="bookmark"]').removeClass('active');
                }

                $obj.addClass('active');
              }
            }).catch(err => {
              console.log(err);
            });
          },
          remove: $obj => {
            const $bookmarkContainer = $obj.closest('[data-bookmark]');

            const bookmarkConfig = $bookmarkContainer.data('bookmark');

            ajax.run({
              url: bookmarkConfig.urls.remove
            }).then(json => {
              if (json.status === 'success') {
                $obj.removeClass('active');
              }
            }).catch(err => {
              console.log(err);
            });
          },
          render: ($container=$('body'), bookmarks=null) => {
            if (bookmarks !== null) {
              $.bookmark.renderIcons($container, bookmarks);
              return;
            }

            const endpoints = {};

            $container.find('[data-bookmark-icon]').each(function () {
              const config = $(this).data('bookmark-icon');

              if (!endpoints[config.url]) {
                endpoints[config.url] = [];
              }

              endpoints[config.url].push(config.id.toString());
            });

            Object.entries(endpoints).forEach(function ([url, toRender]) {
              $.ajax({
                url,
                contentType: 'application/json',
                data: JSON.stringify(toRender),
                method: 'post',
                success: (res) => {
                  $.bookmark.renderIcons($container, res)
                }
              })
            })
          },
          renderIcons: ($container, bookmarks) => {
            $container.find('[data-bookmark-icon]').each(function () {
              const config = $(this).data('bookmark-icon');
              if (bookmarks[config.id] === undefined) {
                return;
              }

              const icon = bookmarks[config.id] ? config.iconBookmark : config.iconNotBookmark;

              $(this).html(icon);
            });
          }
        }
      });
    })($);

    const initBookmark = () => {
      $('[data-bookmark]:not([data-has-bookmark])').each(function() {
        $.bookmark.init($(this));
      });
    };

    initBookmark();
    $.bookmark.render()

    $(document).on('handlebars.render.end', function(e, $container) {
      initBookmark();
      $.bookmark.render($container)
    });

    $('body').on('click', '[data-toggle="bookmark"]', function(e) {
      e.preventDefault();

      $.bookmark.toggle($(this));
    });
  }
}
